import Heading from 'LuxKit/Typography/Heading'
import { useIntl } from 'react-intl'

export function UnfilteredResults() {
  const intl = useIntl()

  return (
    <Heading colour="dark-contrast" variant="heading1">
      {intl.formatMessage({
        id: 'LNfAwUEzhN3ogSuPwm3U',
        defaultMessage: 'Travel inspiration',
        description: 'Hero heading for unfiltered holiday type landing page',
      })}
    </Heading>
  )
}
